import Swiper from 'swiper/bundle';
import { disableBodyScroll, enableBodyScroll } from '~js/utils/dom';

export const initWatchLearnCarousel = () => {
  const container = document.querySelector('.watchlearn_carousels__container');
  if (!container) return;

  const swiper = new Swiper(container, {
    slidesPerView: 1.5,
    spaceBetween: 16,
    navigation: {
      nextEl: '.watchlearn_carousels__swiperNextBtn',
      prevEl: '.watchlearn_carousels__swiperPrevBtn',
    },
    pagination: {
      el: '.watchlearn_carousels__pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return `<span class="${className} w-2.5 h-2.5 rounded-full bg-gray-200 transition-all duration-300 ease-in-out"></span>`;
      },
    },
    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 32,
      },
    },
    on: {
      init(swiper) {
        updateNavigationState(swiper);
        updatePaginationStyle();
        setupVideoPrompt();
      },
      slideChange(swiper) {
        updateNavigationState(swiper);
        updatePaginationStyle();
      },
    },
  });

  function updatePaginationStyle() {
    const bullets = document.querySelectorAll(
      '.watchlearn_carousels__pagination .swiper-pagination-bullet',
    );

    bullets?.forEach((bullet) => {
      if (!bullet) return;

      if (bullet.classList.contains('swiper-pagination-bullet-active')) {
        bullet.classList.add('w-5', 'h-2.5', 'rounded-md', 'bg-gray-900');
        bullet.classList.remove(
          'w-2.5',
          'h-2.5',
          'rounded-full',
          'bg-gray-200',
        );
      } else {
        bullet.classList.add('w-2.5', 'h-2.5', 'rounded-full', 'bg-gray-200');
        bullet.classList.remove('w-5', 'h-2.5', 'rounded-md', 'bg-gray-900');
      }
    });
  }

  function updateNavigationState(swiper) {
    if (!swiper) return;

    const prevBtn = document.querySelector(
      '.watchlearn_carousels__swiperPrevBtn',
    );
    const nextBtn = document.querySelector(
      '.watchlearn_carousels__swiperNextBtn',
    );
    if (!prevBtn || !nextBtn) return;
    if (prevBtn) {
      prevBtn.style.display = swiper.isBeginning ? 'none' : 'flex';
    }
    if (nextBtn) {
      nextBtn.style.display = swiper.isEnd ? 'none' : 'flex';
    }
  }

  function setupVideoPrompt() {
    const videoButtons = document.querySelectorAll('.js__openVideo');
    if (!videoButtons?.length) return;

    videoButtons.forEach((button) => {
      if (!button) return;

      const newButton = button.cloneNode(true);
      button.replaceWith(newButton);

      newButton?.addEventListener('click', () => {
        const videoUrl = newButton.dataset?.video;
        if (videoUrl) {
          const embedUrl = getEmbedURL(videoUrl);
          if (embedUrl) {
            openVideoOverlay(embedUrl);
          }
        }
      });
    });
  }

  function getEmbedURL(youtubeURL) {
    if (!youtubeURL) return null;

    try {
      const url = new URL(youtubeURL);
      let videoId = url.searchParams.get('v');

      if (!videoId && url.hostname === 'youtu.be') {
        videoId = url.pathname.slice(1);
      }

      return videoId
        ? `https://www.youtube.com/embed/${videoId}?autoplay=1`
        : null;
    } catch (e) {
      console.error('Invalid YouTube URL', youtubeURL);
      return null;
    }
  }

  function openVideoOverlay(url) {
    if (!url || document.querySelector('.js__videoOverlay')) return;

    const overlay = document.createElement('div');
    overlay.classList.add(
      'js__videoOverlay',
      'fixed',
      'inset-0',
      'z-[100]',
      'flex',
      'items-center',
      'justify-center',
      'bg-blue-950',
      'bg-opacity-50',
      'p-4',
    );

    const wrapper = document.createElement('div');
    wrapper.classList.add('relative', 'inline-block');

    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.classList.add(
      'w-[374px]',
      'h-[210px]',
      'lg:w-[560px]',
      'lg:h-[315px]',
      'max-w-3xl',
      'aspect-video',
    );
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
    );
    iframe.setAttribute('allowfullscreen', 'true');

    if (typeof disableBodyScroll === 'function') {
      disableBodyScroll();
    }

    const closeBtn = document.createElement('button');
    closeBtn.classList.add(
      'absolute',
      '-top-9',
      'right-0',
      'text-white',
      'text-2xl',
      'z-[101]',
    );
    closeBtn.innerHTML = `
      <div class="h-8 w-8 bg-gray-100 border border-blue-950 flex justify-center items-center rounded-full">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
          <g clip-path="url(#clip0_3049_23514)">
            <path d="M13.1396 4.23193L4.13965 13.2319" stroke="#002551" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.1396 13.2319L4.13965 4.23193" stroke="#002551" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_3049_23514">
              <rect width="16" height="16" fill="white" transform="translate(0.639648 0.731934)"/>
            </clipPath>
          </defs>
        </svg>
      </div>`;

    closeBtn.onclick = () => {
      overlay?.remove();
      if (typeof enableBodyScroll === 'function') {
        enableBodyScroll();
      }
    };

    overlay?.addEventListener('click', (event) => {
      if (wrapper && !wrapper.contains(event.target)) {
        overlay.remove();
        if (typeof enableBodyScroll === 'function') {
          enableBodyScroll();
        }
      }
    });

    wrapper?.appendChild(closeBtn);
    wrapper?.appendChild(iframe);
    overlay?.appendChild(wrapper);
    document.body?.appendChild(overlay);
  }
};
